module.exports = __webpack_public_path__ + "img/图标2.af7a7bc5.png";